"use client"

import { useMediaQuery } from "usehooks-ts";

export const Title = ({ text }: { text: string }) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    return (
        <p className={`whitespace-pre-line text-xl md:text-3xl lg:text-5xl font-semibold ${isMobile ? "text-center my-5" : "my-10"}`}>{text}</p>
    )
}